export default "__VITE_ASSET__ClP4y73t__"